<template>
  <div class="ccgd-filters">
    <div class="ccgd-filters__row">
      <label v-if="available.loan" class="ccgd-f">
        <span class="ccgd-f__lbl">Loan #</span>
        <input class="ccgd-f__input" type="text" placeholder="Contains..." :value="modelValue.loan" @input="set('loan', $event.target.value)" />
      </label>

      <label v-if="available.borrower" class="ccgd-f">
        <span class="ccgd-f__lbl">Borrower</span>
        <input class="ccgd-f__input" type="text" placeholder="Contains..." :value="modelValue.borrower" @input="set('borrower', $event.target.value)" />
      </label>

      <label v-if="available.created" class="ccgd-f">
        <span class="ccgd-f__lbl">Task requested</span>
        <select class="ccgd-f__input" :value="modelValue.createdPreset" @change="set('createdPreset', $event.target.value)">
          <option value="all">Any time</option>
          <option value="30">Last 30 days</option>
          <option value="90">Last 90 days</option>
          <option value="180">Last 6 months</option>
          <option value="365">Last 12 months</option>
          <option value="older365">Older than 12 months</option>
          <option value="custom">Custom range...</option>
        </select>
      </label>

      <template v-if="available.created && modelValue.createdPreset === 'custom'">
        <label class="ccgd-f">
          <span class="ccgd-f__lbl">From</span>
          <input class="ccgd-f__input" type="date" :value="modelValue.createdFrom" @change="set('createdFrom', $event.target.value)" />
        </label>
        <label class="ccgd-f">
          <span class="ccgd-f__lbl">To</span>
          <input class="ccgd-f__input" type="date" :value="modelValue.createdTo" @change="set('createdTo', $event.target.value)" />
        </label>
      </template>

      <label v-if="available.close" class="ccgd-f">
        <span class="ccgd-f__lbl">Est. close from</span>
        <input class="ccgd-f__input" type="date" :value="modelValue.closeFrom" @change="set('closeFrom', $event.target.value)" />
      </label>
      <label v-if="available.close" class="ccgd-f">
        <span class="ccgd-f__lbl">Est. close to</span>
        <input class="ccgd-f__input" type="date" :value="modelValue.closeTo" @change="set('closeTo', $event.target.value)" />
      </label>

      <label class="ccgd-f">
        <span class="ccgd-f__lbl">Sort by</span>
        <select class="ccgd-f__input" :value="modelValue.sortBy" @change="set('sortBy', $event.target.value)">
          <option value="default">Loan #</option>
          <option v-if="available.created" value="createdDesc">Newest task first</option>
          <option v-if="available.created" value="createdAsc">Oldest task first</option>
          <option v-if="available.close" value="closeAsc">Est. close (soonest)</option>
          <option v-if="available.close" value="closeDesc">Est. close (latest)</option>
        </select>
      </label>
    </div>

    <div class="ccgd-filters__row ccgd-filters__row--meta">
      <label v-if="available.close && (modelValue.closeFrom || modelValue.closeTo)" class="ccgd-f-check">
        <input type="checkbox" :checked="modelValue.includeNoClose" @change="set('includeNoClose', $event.target.checked)" />
        <span>Include loans with no est. close date</span>
      </label>
      <span v-if="activeCount" class="ccgd-filters__summary">
        Showing {{ shownTasks }} of {{ totalTasks }} {{ totalTasks === 1 ? 'item' : 'items' }}
      </span>
      <button v-if="activeCount" type="button" class="ccgd-filters__clear" @click="$emit('clear')">
        <i class="fa-duotone fa-filter-circle-xmark"></i> Clear filters ({{ activeCount }})
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "GridDialogFilters",
  props: {
    modelValue: { type: Object, required: true },
    available: { type: Object, default: () => ({ loan: true, borrower: true, created: false, close: false }) },
    activeCount: { type: Number, default: 0 },
    shownTasks: { type: Number, default: 0 },
    totalTasks: { type: Number, default: 0 }
  },
  emits: ["update:modelValue", "clear"],
  methods: {
    set(key, value) {
      this.$emit("update:modelValue", { ...this.modelValue, [key]: value })
    }
  }
}
</script>

<style scoped>
.ccgd-filters {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 8px 10px;
  margin-top: 8px;
  border: 1px solid #e3e8f0;
  border-radius: 10px;
  background: #fff;
}
.ccgd-filters__row {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: flex-end;
}
.ccgd-filters__row--meta {
  align-items: center;
  min-height: 0;
}
.ccgd-filters__row--meta:empty {
  display: none;
}
.ccgd-f {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin: 0;
}
.ccgd-f__lbl {
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: #6b7a90;
}
.ccgd-f__input {
  height: 38px;
  min-width: 150px;
  padding: 0 10px;
  font-size: 14px;
  border: 1px solid #cfd8e3;
  border-radius: 6px;
  background: #fff;
  color: #16305a;
}
.ccgd-f__input:focus {
  outline: none;
  border-color: #5b9ff1;
  box-shadow: 0 0 0 2px rgba(91, 159, 241, 0.2);
}
.ccgd-f-check {
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 0;
  font-size: 14px;
  color: #3b4a60;
}
.ccgd-filters__summary {
  font-size: 14px;
  color: #6b7a90;
  margin-left: auto;
}
.ccgd-filters__clear {
  border: 1px solid #cfd8e3;
  background: #f5f8fc;
  color: #16305a;
  border-radius: 6px;
  padding: 6px 12px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}
.ccgd-filters__clear:hover {
  background: #e9f1fc;
}
@media (max-width: 700px) {
  .ccgd-f { flex: 1 1 45%; }
  .ccgd-f__input { min-width: 0; width: 100%; }
}
</style>
